<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryVolumesByGroupIdList" :height="500">
    </Table>
  </div>
</template>
<script>
    var tableVolume = {}
    export default {
        name: 'TableVolume',
        data() {
            return {
                Name: '',
                modalLoading: false,
              columns: [
                {
                  title: this.$t('rule_engine.name'),
                  key: 'name'
                },
                {
                  title: this.$t('rule_engine.instanceId'),
                  key: 'volumeAwsId'
                },
                {
                  title: this.$t('rule_engine.deviceName'),
                  key: 'deviceName'
                },
                {
                  title: this.$t('rule_engine.volumeId'),
                  key: 'volumeAwsId'
                },
                {
                  title: this.$t('rule_engine.capacity'),
                  key: 'capacity'
                },
                {
                  title: this.$t('alarms.common.scanType'),
                  key: 'type'
                },
                {
                  title: this.$t('rule_engine.readSpeed'),
                  key: 'iops'
                },

                {
                  title: this.$t('rule_engine.area'),
                  key: 'region'
                },
              ],
              queryVolumesByGroupIdList: []
            }
        },
        beforeCreate: function () {
          tableVolume = this
        },
        mounted: function () {
          tableVolume.queryInstancesByGroupId()
        },
        methods: {
          queryInstancesByGroupId: function () {
            this.modalLoading = true
            tableVolume.$api.alertRule.selectInstantiationByAlertRule('id', this.$route.query.id)
              .then(res => {
                this.queryVolumesByGroupIdList = res.data[0].volumeList;
                this.modalLoading = false
              })
              .catch(res => {
                // 如果列表里没数据 返回
                this.queryVolumesByGroupIdList = undefined
              })
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rule_engine/TableVolume.vue